export const SITE_CONFIG = {
  storeName: 'Q-Sport',
  tagline: 'Dụng Cụ Cầu Lông & Phụ Kiện Thể Thao Chính Hãng',
  representative: 'Lã Thành Quyết',
  email: 'ltquyet@qsport.vn',
  phone: '0987 654 321 (Minh họa)',
  address: '56 Đ. Số 2, Thủ Đức, Hồ Chí Minh',

  // Default Bank Details
  bankName: 'MB',
  bankAccountNumber: '0999999888',
  bankAccountHolder: 'TAI KHOAN DEMO',

  // Embed & Channel URLs
  youtubeChannelUrl: 'https://www.youtube.com/@congdongvnb',
  youtubeEmbedUrl: 'https://www.youtube.com/embed/1fRPTsCSfK8?si=RNedddD1pdM0vjQu',
  mapsEmbedUrl: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3918.443660943714!2d106.7583648!3d10.8538289!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31752797e8cb3725%3A0x6fb837b01d0a519!2zNTYvMSDEkC4gU-G7kSAyLCBMaSWGrW5nIENoaeG7g3UsIFRo4bunIMSQ4bupYywgSOG7kyBDaMOtIE1pbmgsIFZpZXRuYW0!5e0!3m2!1svi!2s!4v1700000000000!5m2!1svi!2s',

  // Persistent Demo Notice Text
  demoNoticeText:
    '⚠️ WEBSITE DEMO HỌC TẬP — KHÔNG NHẰM MỤC ĐÍCH THƯƠNG MẠI. Một số hình ảnh và nội dung được sử dụng cho mục đích minh họa, tham khảo từ XSport, ShopVNB và các nguồn Internet. Quyền sở hữu thuộc về chủ sở hữu tương ứng. Website phục vụ đồ án Vibecode và dự kiến ngừng hoạt động sau khi kết thúc khóa học.',
};
